import React, { useContext } from 'react';
import { StoreContext } from '../containers/Store';
import { Steps } from 'antd';
import activities from '../data/activities';

import * as ROLES from '../constants/roles';

const Path = (props) => {
  const {
    user: {
      user
    },
    drawer: {
      setRightDrawer,
      setRightDrawerTitle,
      setStepId,
      setReference,
    },
    action: {
      resetActivity
    }
  } = useContext(StoreContext);

  const Step = Steps.Step;

  const extractTitle = (activityId, pathId) => {
    if (!!activities) {
      if (activities.filter(act =>
          act.activity === activityId &&
          act.path === pathId).length > 0) {
        return activities.filter(act =>
          act.activity === activityId  &&
          act.path === pathId)[0].name;
      } else {
        return ""
      }
    } else {
      return ""
    }
  }

  const extractDescription = (activityId, pathId, userRole) => {
    if (!!activities) {
      if (activities.filter(act =>
        act.activity === activityId &&
        act.path === pathId).length > 0) {
          if (userRole === ROLES.STUDENT_DEMO) {
            return activities.filter(act =>
              act.activity === activityId &&
              act.path === pathId)[0].student_objective;
          } else {
            return activities.filter(act =>
              act.activity === activityId &&
              act.path === pathId)[0].teacher_objective;
          }
      } else {
        return ""
      }
    } else {
      return ""
    }
  }

  return (
    <div style={window.innerWidth < 520 ? {
      padding: '30px',
      paddingLeft: '0px',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'top',
    } : {
      padding: '30px',
      paddingLeft: '0px',
      display: 'flex',
      height: '80vh',
      justifyContent: 'space-around',
      alignItems: 'top'
    }}>
      <Steps direction="vertical" current={props.activityId}>
        {!!user && user.roles.includes(ROLES.STUDENT_DEMO) && <Step
          title={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Test diagnostique` : extractTitle(0, 0)}
          description={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            extractDescription(0, 0, ROLES.STUDENT_DEMO) :
            extractDescription(0, 0, ROLES.TEACHER_DEMO)
          }
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setRightDrawerTitle(!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Test diagnostique` : extractTitle(0, 0));
            setRightDrawer(true);
            setStepId(0);
          }}
        />}
        <Step
          title={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 1` : extractTitle(1, props.path)}          
          description={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            extractDescription(1, props.path, ROLES.STUDENT_DEMO) :
            extractDescription(1, props.path, ROLES.TEACHER_DEMO)
          }
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setRightDrawerTitle(!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 1` : extractTitle(1, props.path));
            setRightDrawer(true);
            if (!!user && user.roles.includes(ROLES.STUDENT_DEMO)) {
              setStepId(1);
            } else {
              setReference([1, props.path]);
              resetActivity({ activityId: 1, path: props.path })
            }
          }}
        />
        <Step
          title={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 2` : extractTitle(2, props.path)}
            description={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
              extractDescription(2, props.path, ROLES.STUDENT_DEMO) :
              extractDescription(2, props.path, ROLES.TEACHER_DEMO)
            }
            style={{ cursor: 'pointer' }}
          onClick={() => {
            setRightDrawerTitle(!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 2` : extractTitle(2, props.path));
            setRightDrawer(true);
            if (!!user && user.roles.includes(ROLES.STUDENT_DEMO)) {
              setStepId(2);
            } else {
              setReference([2, props.path]);
              resetActivity({ activityId: 2, path: props.path })
            }
          }}
        />
        <Step
          title={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 3` : extractTitle(3, props.path)}
            description={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
              extractDescription(3, props.path, ROLES.STUDENT_DEMO) :
              extractDescription(3, props.path, ROLES.TEACHER_DEMO)
            }
            style={{ cursor: 'pointer' }}
          onClick={() => {
            setRightDrawerTitle(!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 3` : extractTitle(3, props.path));
            setRightDrawer(true);
            if (!!user && user.roles.includes(ROLES.STUDENT_DEMO)) {
              setStepId(3);
            } else {
              setReference([3, props.path]);
              resetActivity({ activityId: 3, path: props.path })
            }
          }}
        />
        <Step
          title={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 4` : extractTitle(4, props.path)}
            description={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
              extractDescription(4, props.path, ROLES.STUDENT_DEMO) :
              extractDescription(4, props.path, ROLES.TEACHER_DEMO)
            }
            style={{ cursor: 'pointer' }}
          onClick={() => {
            setRightDrawerTitle(!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 4` : extractTitle(4, props.path));
            setRightDrawer(true);
            if (!!user && user.roles.includes(ROLES.STUDENT_DEMO)) {
              setStepId(4);
            } else {
              setReference([4, props.path]);
              resetActivity({ activityId: 4, path: props.path })
            }
          }}
        />
        <Step
          title={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 5` : extractTitle(5, props.path)}
            description={!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
              extractDescription(5, props.path, ROLES.STUDENT_DEMO) :
              extractDescription(5, props.path, ROLES.TEACHER_DEMO)
            }
            style={{ cursor: 'pointer' }}
          onClick={() => {
            setRightDrawerTitle(!!user && user.roles.includes(ROLES.STUDENT_DEMO) ?
            `Activité 5` : extractTitle(5, props.path));
            setRightDrawer(true);
            if (!!user && user.roles.includes(ROLES.STUDENT_DEMO)) {
              setStepId(5);
            } else {
              setReference([5, props.path]);
              resetActivity({ activityId: 5, path: props.path })
            }
          }}
        />
        <Step
          title={'Test final'}
        />
        </Steps>
        
    </div>
  );
};

export default Path;